module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"pt-BR":{"shipping":"Entrega","address":"Endereço","recipient":"Destinatário","billingEqualShipping":"O endereço de cobrança é igual ao de entrega"},"en-US":{"shipping":"Shipping","address":"Address","recipient":"Recipient","billingEqualShipping":"Use same Billing Address"}}')
  delete Component.options._Ctor
}
